// -- todo - base service class
import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class IntegrationService {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
	}

	createIntegration(integration, callback) {
		const url = "/ecosystem/api/feeds";
		const body = JSON.stringify(integration);
		this._restClient.exec_post(url, body, callback);
	}

	getIntegration(intId, callback) {
		const url = `/ecosystem/api/feeds/${intId}`;
		this._restClient.exec_get(url, callback);
	}

	getIntegrationOrgProfile(intId, orgId, callback) {
		const url = `/ecosystem/api/feeds/${intId}/orgProfile/${orgId}`;
		this._restClient.exec_get(url, callback);
	}

	getAll(callback) {
		const url = "/ecosystem/api/feeds";
		// If gets passed a callback, executes normally. Otherwise returns promise for use with async/await, etc.
		if (callback) {
			this._restClient.exec_get(url, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_get(url, (err, result) => {
					if (err) {
						reject(err);
						return;
					}
					resolve(result);
				});
			});
		}
	}

	getShareProfile(intId, callback) {
		const url = `/ecosystem/api/feeds/${intId}/shareProfile`;
		this._restClient.exec_get(url, callback);
	}

	getExternalSystemLookup(externalSystemId, lookupType, callback) {
		let url = `/integration-app/api/externalSystem/${externalSystemId}/lookup/${lookupType}`;
		// handle additional query parameters
		if (arguments.length > 3) {
			url += `?${arguments[3]}`;
		}
		this._restClient.exec_get(url, callback);
	}

	getExternalSystem(externalSystemId, callback) {
		const url = `/ecosystem/api/externalSystem/${externalSystemId}`;
		this._restClient.exec_get(url, callback);
	}

	postExternalSystemResource(externalSystemId, resourceType, resourceData, callback) {
		const request = {
			url: `/integration-app/api/externalSystem/${externalSystemId}/resource/${resourceType}`
		};

		if (resourceData?.timeout) {
			request.timeout = resourceData.timeout;
		}

		const body = JSON.stringify(resourceData);
		this._restClient.exec_post(request, body, callback);
	}
}
